import { useSelector } from 'react-redux'

import LineCard from '../../../components/ReusableComponents/Charts/Inslghts/Line/index'
import styles from '../Insights.module.scss'

const DirectBookings = () => {
  const directPerformances = useSelector(s => s.insights.directPerformances.last12Months)

  return (
    <div className={styles.row}>
      {directPerformances && (
        <LineCard
          title="Direct bookings"
          subtitle="For last 12 months"
          yLabel="Bookings"
          data={Object.values(directPerformances).map(({ numberOfBookings, name }) => ({
            bookings: numberOfBookings,
            name
          }))}
          barSize={15}
          height={250}
        />
      )}
    </div>
  )
}

export default DirectBookings
